export enum AnnualReportShareInvitationActions {
    ACCEPT_SHARE = 'accept share',
    DECLINE_SHARE = 'decline share',
}
